import { Component, Input } from '@angular/core';
import { Projection } from '../models';
import { FormatDatePipe } from 'src/app/miscellaneous/pipes/format-date.pipe';
import { Store } from '@ngrx/store';
import { NavigationService } from 'src/app/services/navigation.service';
import { selectReadOnlyBooking } from '../../pickup-declarations/state/actions';

@Component({
  selector: 'app-bobby-calves-calves-picked-up-digital-declaration-card',
  templateUrl: './bobby-calves-calves-picked-up-digital-declaration-card.component.html',
  styleUrls: ['./bobby-calves-calves-picked-up-digital-declaration-card.component.scss'],
})
export class BobbyCalvesPickedUpDigitalDeclarationCardComponent {
  @Input() pickup: Projection.Pickup;

  constructor(
    private readonly store: Store,
    private readonly dateFormatter: FormatDatePipe,
    private readonly navigationService: NavigationService,
  ) {}

  public get date(): string {
    return this.dateFormatter.transform(this.pickup.date, 'dwdm');
  }

  public showDeclaration(): void {
    this.store.dispatch(selectReadOnlyBooking({
      propertyId: this.pickup.anzcoPropertyId,
      bookingId: this.pickup.booking.id,
    }));
    this.navigationService.pickupDeclarations();
  }
}